import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useBillableEvent} from '../hooks/useBillableEvent.ts';

// FNP-533: read-only detail view. No edit drawer / tools — pipeline owns the
// lifecycle. Renders the full record plus the pretty-printed channelPayload and
// channelResponse payloads.
export const DetailPage = () => {
    const {id: billableEventId} = useParams();

    if (typeof billableEventId === 'undefined') {
        throw new Error('billableEventId is required parameter');
    }

    const {
        record: billableEvent,
        loading,
        isError,
        notFound,
    } = useBillableEvent(billableEventId);

    if (loading) {
        return <PlatformLoader message='Loading billable event...Please wait'/>;
    }

    // Never hang on the loader: once the query has settled, a missing record or an
    // error gets an explicit message rather than an indefinite spinner.
    if (isError || notFound || !billableEvent) {
        return (
            <Alert color='red' title='Billable event not found'>
                No billable event found for id <code>{billableEventId}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={billableEvent.id}
            pageNavigation={<EditPageNavigation component={billableEvent}/>}
        >
            <Stack gap='lg'>
                <Profile record={billableEvent}/>
            </Stack>
        </FormPageLayout>
    );
};
